import { draftToHtmlWithLineBreaks } from 'util/draftToHtmlWithLineBreaks';

import { RawDraftContentState } from 'draft-js';
import {
  mapScheduleDtoToModel,
  mapScheduleModelToDto,
  ScheduleDto,
  ScheduleModel,
} from 'api/dto/Schedule.dto';

import { JobDto } from './JobExtended.dto';

export type EmailTemplateType = 'invitation' | 'reminder';

export type EmailTemplateDto = {
  id?: number;
  type?: string;
  title: string;
  content: string;
  job?: JobDto;
  senderName?: string;
  replyTo?: string;
  replyToName?: string;
  htmlContent?: string;
  schedules?: ScheduleDto[];
  scheduleRelativeDate?: string;
  sendAtTime?: string | null;
};

export type EmailTemplateModel = {
  id?: number;
  type: EmailTemplateType;
  title?: string;
  senderName?: string;
  jobId?: number;
  replyTo?: string;
  replyToName?: string;
  content?: RawDraftContentState;
  htmlContent?: string;
  schedules?: ScheduleModel[];
  scheduleRelativeDate?: string;
  sendAtTime?: string | null;
};

export function mapEmailTemplateModelToDto(model: EmailTemplateModel): EmailTemplateDto {
  return {
    id: model.id,
    title: model.title,
    senderName: model.senderName,
    replyTo: model.replyTo,
    replyToName: model.replyToName,
    content: JSON.stringify(model.content),
    htmlContent: EmailTemplateModel.getHtmlContent(model),
    schedules: model.schedules?.map(mapScheduleModelToDto),
  };
}

export function mapEmailTemplateDtoToModel(dto: EmailTemplateDto): EmailTemplateModel {
  let content;

  try {
    content = JSON.parse(dto.content);
  } catch (e) {
    console.error(e);
    content = null;
  }

  return {
    id: dto.id,
    type: dto.type as EmailTemplateType,
    title: dto.title,
    senderName: dto.senderName,
    replyTo: dto.replyTo,
    replyToName: dto.replyToName,
    content: content,
    htmlContent: dto.htmlContent,
    schedules: dto.schedules ? dto.schedules.map(mapScheduleDtoToModel) : undefined,
    scheduleRelativeDate: dto.scheduleRelativeDate,
    sendAtTime: dto.sendAtTime ?? null,
    jobId: dto.job ? dto.job.id : null,
  };
}

export namespace EmailTemplateModel {
  export function getHtmlContent(emailTemplate: EmailTemplateModel): string {
    return emailTemplate.content ? draftToHtmlWithLineBreaks(emailTemplate.content) : '';
  }
}
